export default __webpack_public_path__ + "static/media/walkthrough-text-bubble.806fc375.svg";